import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import LoginService from 'services/Login/service';
import { passwordValidation } from 'config/utils';
import './style.scss';
import { recaptcha } from 'config';
import useScript from '../../hooks/useScript'

const FormChangePass = ({ processData = null, userData = {} }) => {

    useScript(`https://www.google.com/recaptcha/enterprise.js?render=${recaptcha.site_key}`);
    window.onSubmit = () =>{
        document.getElementById("btn-submit").click();
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Evitar el comportamiento predeterminado del Enter
            document.getElementById("recaptcha-button").click();
        }
    };
    
    const [errorProcess, setErrorProcess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        handleChange,
        data,
        errors,
    } = useForm({
        validations: {
            ...passwordValidation
        },
        onSubmit: async(data) => {
            setIsLoading(true);
            setErrorProcess('');
            try{
                let token = document.getElementsByName('g-recaptcha-response')[0].value;
 
                let body = {
                    'email': userData.email,
                    'platform': recaptcha.platform,
                    'token': token
                };
                let preRecovery = await LoginService.authPreRecovery(body);
                if(!preRecovery || !preRecovery.payload || preRecovery.internalCode!=='200'){
                    window.location.reload();
                    return;
                }

                let authToken = await LoginService.authToken({'user': preRecovery.payload}, 'reset');
                if(!authToken || !authToken.payload || authToken.internalCode!=='200'){
                    setErrorProcess('Usuario no registrado');
                    setIsLoading(false);
                    return;
                }
                userData.user = preRecovery.payload;
                userData.password = data.password;
                processData && processData(3, userData); 
              
            }catch(error){
                console.error(error);
            }
        },
        initialValues: {
            password: '', 
            password_confirm: '', 
        }
    });

    return (
        <>
        <form onSubmit={handleSubmit}>
            <div className="form-group">
                <label>Ingresa tu nueva contraseña</label>
                <input value={data.password || ''} onChange={handleChange('password')} required maxLength="20" type="password" className="form-control" name="textBoxPassword" id="textBoxPassword" placeholder="" />
                {errors.password && 
                    (errors.password.html ? 
                        <div className="password-requirements">
                            <span className="password-requirements-description">La contraseña debe tener: </span>
                            <ul className="password-requirements-list" dangerouslySetInnerHTML={{__html: errors.password.html}}></ul>
                        </div>
                        :
                        <p className="error-form">{errors.password}</p>
                    )
                }
            </div>
            <div className="form-group mb-4 mb-lg-5">
                <label>Confirma nueva contraseña</label>
                <input value={data.password_confirm || ''} onChange={handleChange('password_confirm')} required maxLength="20" type="password" className="form-control" name="textBoxPassword2" id="textBoxPassword2" placeholder="" onKeyDown={handleKeyPress} />
                {errors.password_confirm && <p className="error-form">{errors.password_confirm}</p>}
            </div>
            <div>
                <input id="btn-submit" type={"submit"} style={{display:'none'}}></input>
            </div>
            {errorProcess!=='' && <p className="error-form text-center" style={{ paddingLeft: 0 }} dangerouslySetInnerHTML={{__html: errorProcess}}></p>}
            <p className="buttons text-center">
                {isLoading
                    ?
                    <button type="submit" className="btn btn-primary btn-main no-hover">
                        <Loading type="wong--hover" />
                    </button>
                    :
                    <button
                    id="recaptcha-button"
                    className="btn btn-primary btn-main no-hover g-recaptcha"
                    data-sitekey={recaptcha.site_key}
                    data-callback={'onSubmit'}
                    data-action={recaptcha.action_recovery}
                    >
                    Aceptar
                   </button>                      
                }
            </p>
        </form>
        </>
    );
}

FormChangePass.propTypes = {
    processData: PropTypes.func,
    userData: PropTypes.object
};
export default FormChangePass;